module.exports = __webpack_public_path__ + "static/media/businessOnebg.3a0a0c7d.png";